import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // Importa el hook de traducción
import './SecurityNotice.css';

const SecurityNotice = () => {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(); // Hook para acceder a las traducciones

  const handleAccept = () => {
    setAccepted(true);
    navigate('/register');
  };

  if (accepted) {
    return null; // Oculta el aviso una vez que el usuario lo acepta
  }

  return (
    <div className="security-notice-container">
      <div className="security-notice">
        <h2>{t('welcome')}</h2>
        <p>{t('intro')}</p>

        <div className="security-content">
          <h3>{t('important_notice')}</h3>
          <p>{t('security_details')}</p>

          <h3>{t('key_points_title')}</h3>
          <ul>
            <li>
              <strong>{t('blockchain_risks')}:</strong> {t('blockchain_risks_desc')}
            </li>
            <li>
              <strong>{t('not_deposit_all')}:</strong> {t('not_deposit_all_desc')}
            </li>
            <li>
              <strong>{t('user_responsibility')}:</strong> {t('user_responsibility_desc')}
            </li>
            <li>
              <strong>{t('authentication_security')}:</strong> {t('authentication_security_desc')}
            </li>
          </ul>

          <h3>{t('disclaimer_title')}</h3>
          <p>{t('disclaimer_desc')}</p>

          <h3>{t('key_features_title')}</h3>
          <ul>
            <li><strong>{t('address_generation')}</strong></li>
            <li><strong>{t('send_menelik')}</strong></li>
            <li><strong>{t('check_balances')}</strong></li>
            <li><strong>{t('transaction_history')}</strong></li>
            <li><strong>{t('manage_utxos')}</strong></li>
            <li><strong>{t('manage_smartnodes')}</strong></li>
            <li><strong>{t('staking')}</strong></li>
            <li><strong>{t('games_rewards')}</strong></li>
          </ul>
        </div>

        <p>{t('accept_terms')}</p>

        <button className="accept-button" onClick={handleAccept}>{t('accept')}</button>
      </div>
    </div>
  );
};

export default SecurityNotice;
